import React from 'react';
import moment from 'moment';
import Table from '../../component/Table';
import DatePicker from 'react-datepicker';
import CustomDatePicker from '../../component/CustomDatePicker';
import PrintRmJb, { PrintRmJbEdit } from './component/PrintRmJb';
import PrintHotel, { PrintHotelEdit } from './component/PrintHotel';
import printJS from 'print-js';
import apiService from 'apiService';
const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
  <input
    ref={ref}
    type='text'
    className='form-control form-control-sm'
    defaultValue={value}
    onClick={onClick}
    style={{ width: '100%' }}
  />
));

const AdminView = ({
  values,
  lists,
  date,
  isLoading,
  dateOnChange,
  handleSelectChange,
  handleSubmit,
  isShow = true,
  showVerificationForm,
  showPenilaianForm,
  print,
  printEdit,
}) => {
  //hotel 
  const requestPrintBAP = async (id) => {
    const res = await apiService.getblob("/hotel/registration/print-berita-acara/" + id);
    if (res) {
      const file = new Blob([res], { type: 'application/pdf' });
      //Build a URL from the file
      const fileURL = URL.createObjectURL(file);
      //print blob
      printJS(fileURL);
    }
  };
  const requestPrintHotel = async (id) => {
    const res = await apiService.getblob("/hotel/registration/print-lolos-kunjungan/" + id);
    if (res) {
      const file = new Blob([res], { type: 'application/pdf' });
      //Build a URL from the file
      const fileURL = URL.createObjectURL(file);
      //print blob
      printJS(fileURL);
    }
  };
  //hotel
  if (!isShow) return '';
  return (
    <div className='container-fluid mt-2'>
      <div className='row'>
        <div className='col'>
          <div className='card'>
            <div className='card-header border-0'>
              <div className='row'>
                {/* <div className='col-md-2'>
                  <h3>Kata Kunci</h3>
                </div>

                <input
                  className='form-control col-md-4'
                  name='katakunci'
                  placeholder='nama'
                  type='text'
                  onChange={handleInputChange}
                /> */}
                <div className='col-md-2'>
                  <h3>Filter</h3>
                </div>
                <div className='col-md-2'>
                  <select
                    className='form-control  '
                    name='katakunci'
                    placeholder='nama'
                    onChange={handleSelectChange}>
                    <option value={1}>Rumah Makan</option>
                    <option value={2}>Jasaboga</option>
                    <option value={3}>Hotel</option>
                  </select>
                </div>
              </div>
              <div className='row' style={{ marginTop: '2%' }}>
                <div className='col-md-2'>
                  <h3>Tanggal daftar</h3>
                </div>
                <div className='col-md-2'>
                  <CustomDatePicker
                    value={date.frDate}
                    onChange={(date) =>
                      dateOnChange(moment(date).format('YYYY-MM-DD'), 'fr')
                    }
                  />
                  {/* <DatePicker
                    customInput={ <CustomInput /> }
                    selected={ date.frDate }
                    onChange={ (date) =>
                      dateOnChange(moment(date).format('YYYY-MM-DD'), 'fr')
                    }
                    // value={ values.frDate }
                    dateFormat='yyyy-MM-dd'
                  /> */}
                </div>
                <div className='col-md-2'>
                  <CustomDatePicker
                    value={date.enDate}
                    onChange={(date) =>
                      dateOnChange(moment(date).format('YYYY-MM-DD'), 'fen')
                    }
                  />
                </div>
                <div className='col-md-2'>
                  <button
                    style={{ marginLeft: '2%' }}
                    className='btn btn-success btn-block'
                    onClick={(e) => handleSubmit(e, values)}>
                    Cari
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='col'>
          <div className='card'>
            <div className='card-header border-0' />
            <Table
              headers={[
                'No',
                'ID',
                'Nama',
                'Nama Perusahaan',
                'Rencana Kunjungan',
                '',
              ]}
              data={lists}
              columnMapper={(value) => {
                const visitDate =
                  value.visit_date_history || value.update_visit_date;

                return [
                  value.id,
                  `${value.patient.name} ${value.patient.last_name}`,
                  value.company_name,
                  visitDate[visitDate.length - 1] &&
                  moment(visitDate[visitDate.length - 1].visit_date).format(
                    'DD-MM-YYYY'
                  ),
                  <>
                    <div className="dropdown">
                      <a className="btn btn-sm btn-icon-only btn-secondary text-light" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i className="fas fa-ellipsis-v " />
                      </a>
                      <div className="dropdown-menu dropdown-menu-right dropdown-menu-arrow " x-placement="bottom-end" style={{ position: 'absolute', willChange: 'transform', top: 0, left: 0, transform: 'translate3d(31px, 32px, 0px)' }}>
                        <a className="dropdown-item" onClick={() => showVerificationForm(values.type, value)}>Verifikasi</a>
                        <a className="dropdown-item" disabled={
                          value.visit_date_history && value.visit_date_history[0]
                            ? false
                            : value.update_visit_date &&
                              value.update_visit_date[0]
                              ? false
                              : true
                        } onClick={() => showPenilaianForm(values.type, value)}>Penilaian</a>
                        {
                          value.hotel_name ? 
                          <>
                            <a className="dropdown-item" onClick={() => requestPrintBAP(value.id)}>Cetak Berita Acara</a>
                            <a className="dropdown-item" onClick={() => requestPrintHotel(value.id)}>Catak Lolos Kunjungan</a>
                          </>
                          : ''
                        }
                        {/* <button
                          className='btn btn-primary'
                          onClick={() => showVerificationForm(values.type, value)}>
                          Verifikasi
                    </button> */}
                        {/* <button
                          disabled={
                            value.visit_date_history && value.visit_date_history[0]
                              ? false
                              : value.update_visit_date &&
                                value.update_visit_date[0]
                                ? false
                                : true
                          }
                          className='btn btn-warning'
                          onClick={() => showPenilaianForm(values.type, value)}>
                          Penilaian
                    </button> */}
                        {value.hasil_penilaian ? (
                          <PrintRmJb
                            values={values}
                            penilaian={value.hasil_penilaian}
                            print={print}
                            id={value.id}
                          />
                        ) : (
                            <PrintHotel
                              values={values}
                              penilaian={value.penilaian}
                              print={print}
                              id={value.id}
                            />
                          )}
                        {value.hasil_penilaian ? (
                          <PrintRmJbEdit
                            values={values}
                            penilaian={value.hasil_penilaian}
                            printEdit={printEdit}
                            id={value.id}
                          />
                        ) : (
                            <PrintHotelEdit
                              values={values}
                              penilaian={value.penilaian}
                              printEdit={printEdit}
                              id={value.id}
                            />
                          )}
                      </div>
                    </div>
                    {/* <button
                      disabled={ true }
                      className='btn btn-success'
                      onClick={ () => print(value.id) }>
                      Cetak Sertifikat
                    </button> */}
                  </>,
                ];
              }}
              pagination={true}
              isLoading={isLoading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminView;
